import { render, staticRenderFns } from "./ModalWindow.vue?vue&type=template&id=ef549c38&scoped=true&"
import script from "./ModalWindow.vue?vue&type=script&lang=ts&"
export * from "./ModalWindow.vue?vue&type=script&lang=ts&"
import style0 from "./ModalWindow.vue?vue&type=style&index=0&id=ef549c38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef549c38",
  null
  
)

export default component.exports